import axios from 'axios';
import { ApolloClient } from 'apollo-boost';

import {
  MediaApiResponse,
  extension,
  genericErrorResponse,
  getMediaApiJwt,
  handleMediaAPIException,
  handleMediaAPIResponse,
  mediaApiUrl,
} from './mediaApiUtils';

interface ReplaceProps {
  apolloClient: ApolloClient<object>;
  file: (File | Blob) & { filename?: string };
  mediaApiId: string;
  memberId: string;
}

const mediaApiReplace = async (props: ReplaceProps): Promise<MediaApiResponse> => {
  const { apolloClient, file, mediaApiId, memberId } = props;

  const apiUrl = mediaApiUrl();
  let token;
  try {
    token = await getMediaApiJwt(apolloClient);
  } catch {
    return (genericErrorResponse as unknown) as MediaApiResponse;
  }

  file.filename = `uploaded.${extension(file)}`;
  const data = new FormData();
  data.append('file', file);
  data.append('ownerIds', memberId);
  data.append('jwt', token!);
  data.append('id', mediaApiId);

  try {
    const res = await axios.put(`${apiUrl}/images/${mediaApiId}`, data, {
      headers: {
        'content-type': `multipart/form-data; boundary=${data.get('_boundary')}`,
      },
    });

    return handleMediaAPIResponse((res as unknown) as MediaApiResponse);
  } catch (error) {
    return handleMediaAPIException(error as Error);
  }
};
export default mediaApiReplace;
